import { render } from "./servicesSold.vue?vue&type=template&id=3f6504f2&ts=true"
import script from "./servicesSold.vue?vue&type=script&lang=ts"
export * from "./servicesSold.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__